import topicsPathwayArray from '../infrastructure/topicsPathwayArray.js';

const FEATURE_UNLOCK_LABELS = {
  'review-cards': 'Review Cards',
  midway: 'The Midway',
  premium: 'Premium Features',
};

const DEFAULT_HEADLINE = 'Start your free 14-day trial';
const TRIAL_SUBHEAD = 'Start your free 14-day trial';
const SIGN_IN_DETAIL = 'Sign in with Google — no credit card needed.';

function toTitleCase(value) {
  if (!value) {
    return '';
  }
  return String(value).replace(/\w\S*/g, (word) => (
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ));
}

function findPathwayEntryBySkillId(skillId) {
  const normalizedSkillId = Number(skillId);
  if (!Number.isFinite(normalizedSkillId)) {
    return null;
  }
  return topicsPathwayArray.find((item) => item.skillId === normalizedSkillId) ?? null;
}

function findTopicDisplayName(unit, topic) {
  const entry = topicsPathwayArray.find(
    (item) => item.unit === unit && item.topic === topic,
  );
  return entry?.topicDisplayName ?? toTitleCase(topic);
}

function resolveUnlockHeadline(context) {
  if (!context) {
    return null;
  }

  if (context.skillId != null && context.skillId !== '') {
    const entry = findPathwayEntryBySkillId(context.skillId);
    if (entry?.skillDisplayName) {
      return `Unlock ${entry.skillDisplayName}`;
    }
  }

  if (context.unit && context.topic) {
    return `Unlock ${findTopicDisplayName(context.unit, context.topic)}`;
  }

  if (context.reason === 'midway-locked') {
    return 'Unlock The Midway';
  }

  const featureKey = typeof context.reason === 'string'
    ? context.reason.replace(/-locked$/, '')
    : context.feature;
  if (featureKey && FEATURE_UNLOCK_LABELS[featureKey]) {
    return `Unlock ${FEATURE_UNLOCK_LABELS[featureKey]}`;
  }

  return null;
}

/**
 * @param {object|null|undefined} context Sign-in modal context from PaywallProvider
 * @returns {{ headline: string, subhead: string|null, detail: string|null }}
 */
export function getSignInModalCopy(context) {
  const unlockHeadline = resolveUnlockHeadline(context);

  if (unlockHeadline) {
    return {
      headline: unlockHeadline,
      subhead: TRIAL_SUBHEAD,
      detail: SIGN_IN_DETAIL,
    };
  }

  return {
    headline: DEFAULT_HEADLINE,
    subhead: SIGN_IN_DETAIL,
    detail: null,
  };
}

export {
  DEFAULT_HEADLINE,
  SIGN_IN_DETAIL,
  TRIAL_SUBHEAD,
};
